import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import Gallery from "./Gallery";
import AddPhoto from "./AddPhoto";
import Swal from "sweetalert2";

Modal.setAppElement("#root");

const PhotoHolder = ({ index }) => {
  const [photos, setPhotos] = useState([]);
  const [toggleCapture, setToggleCapture] = useState(false);

  useEffect(() => {
    if (toggleCapture) {
      setPhotos(JSON.parse(localStorage.getItem("photos" + index)) || []);
    }
    setToggleCapture(false);
  }, [toggleCapture, index]);

  const deletePhoto = (albumKey) => {
    Swal.fire({
      title: "Warnung",
      text: "Das können Sie nicht mehr rückgängig machen!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ja!",
      cancelButtonText: "Abbrechen",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedPhotos = photos.filter((_, key) => key !== albumKey);
        setPhotos(updatedPhotos);
        localStorage.setItem("photos" + index, JSON.stringify(updatedPhotos));
        Swal.fire("Gelöscht!", "Ihre Datei wurde gelöscht.", "success");
      }
    });
  };

  return (
    <>
      <div
        style={{
          border: "1px solid #cecece",
          borderRadius: "0.35rem",
          marginTop: "10px",
        }}
      >
        <label style={{ marginTop: "6px", marginLeft: "10px" }}>
          Anhänge*{" "}
          <i style={{ fontSize: 12 }}>Bitte fügen Sie die Bilder unten bei</i>
        </label>
        <div
          className="row"
          style={{
            paddingLeft: 10,
            paddingRight: 10,
            marginLeft: "2px",
            marginBottom: "10px",
          }}
        >
          {photos.map((photo, key) => (
            <PhotoComponent
              setToggleCapture={setToggleCapture}
              image={photo}
              index={index}
              albumKey={key}
              key={key}
              deletePhoto={() => deletePhoto(key)}
            />
          ))}
          <AddPhoto setToggleCapture={setToggleCapture} index={index} />
        </div>
        {photos.length > 0 && (
          <div className="upload-instructions">
            <i style={{ fontSize: 12, marginLeft: "10px" }}>
              (Klicken Sie auf das Bild, um eine Beschreibung zu schreiben!)
            </i>
          </div>
        )}
      </div>
    </>
  );
};

const PhotoComponent = ({
  image,
  index,
  albumKey,
  setToggleCapture,
  deletePhoto,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const isSmallScreen = window.innerWidth < 768;
  const customStyles = {
    content: {
      top: isSmallScreen ? "50%" : "55%",
      left: "50%",
      right: "auto",
      bottom: isSmallScreen ? "auto" : "10%",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: isSmallScreen ? "90%" : "50%",
      minHeight: isSmallScreen ? "80vh" : "88vh",
    },
  };

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const deleteButtonStyle = {
    border: "none",
    backgroundColor: "transparent",
    color: "rgba(228, 21, 21, 0.8)",
    cursor: "pointer",
    marginLeft: 75,
    marginTop: 180,
  };

  return (
    <>
      <div
        className="col-3"
        style={{
          marginRight: 5,
          marginTop: 5,
          background: `url(${image.decoded_image}) no-repeat center center`,
          backgroundSize: "contain",
          height: 217,
          width: 217,
          border: "1px solid #D9D9D9",
          position: "relative",
        }}
        onClick={openModal}
      >
        <div style={{ cursor: "pointer" }}>
          <button
            style={deleteButtonStyle}
            className="btn btn-danger"
            onClick={(e) => {
              e.stopPropagation();
              deletePhoto();
            }}
          >
            <FontAwesomeIcon icon={faTrashCan} />
          </button>
        </div>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Image Modal"
      >
        <Gallery
          photo={image}
          index={index}
          closeModal={closeModal}
          albumKey={albumKey}
          setToggleCapture={setToggleCapture}
        />
      </Modal>
    </>
  );
};

export default PhotoHolder;
